import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./global/global.css";
import "./i18n";

const rootElement = document.getElementById("root");

if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);
